// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"banner-module__bannerWrapper___Ahj00","banner":"banner-module__banner___ijd94"};